import { render, staticRenderFns } from "./letDeleteFolder.popup-chunk.vue?vue&type=template&id=15ba2412"
import script from "./letDeleteFolder.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./letDeleteFolder.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports